import useRequestContext from 'hooks/user/useRequestContext';
import type { IPosRequest } from 'autogen/swagger/all';

export default function usePointOfSaleRequest() {
    const request = useRequestContext();

    return request?.posRequest || ({} as IPosRequest);
}
